/**
 * Shared Tailwind configuration
 * This config extends Tailwind's default theme with custom design tokens.
 */

const tailwindConfig = {
  theme: {
    extend: {
      fontFamily: {
        sans: ['var(--360-font-family)']
      },
      fontSize: {
        '2xs': [
          'var(--360-font-size-2xs)',
          { lineHeight: 'var(--360-line-height-sm)' }
        ],
        xs: [
          'var(--360-font-size-xs)',
          { lineHeight: 'var(--360-line-height-sm)' }
        ],
        sm: [
          'var(--360-font-size-sm)',
          { lineHeight: 'var(--360-line-height-sm)' }
        ],
        base: [
          'var(--360-font-size-base)',
          { lineHeight: 'var(--360-line-height)' }
        ],
        lg: [
          'var(--360-font-size-lg)',
          { lineHeight: 'var(--360-line-height)' }
        ],
        xl: [
          'var(--360-font-size-xl)',
          { lineHeight: 'var(--360-line-height)' }
        ],
        '2xl': [
          'var(--360-font-size-2xl)',
          { lineHeight: 'var(--360-line-height)' }
        ]
      },
      lineHeight: {
        default: 'var(--360-line-height)',
        sm: 'var(--360-line-height-sm)'
      },
      colors: {
        primary: {
          1: 'var(--blue-1)',
          2: 'var(--blue-2)',
          3: 'var(--blue-3)',
          4: 'var(--blue-4)',
          5: 'var(--blue-5)',
          6: 'var(--blue-6)',
          7: 'var(--blue-7)',
          8: 'var(--blue-8)',
          9: 'var(--blue-9)',
          10: 'var(--blue-10)',
          11: 'var(--blue-11)',
          12: 'var(--blue-12)',
          a1: 'var(--blue-a1)',
          a2: 'var(--blue-a2)',
          a3: 'var(--blue-a3)',
          a4: 'var(--blue-a4)',
          a5: 'var(--blue-a5)',
          a6: 'var(--blue-a6)',
          a7: 'var(--blue-a7)',
          a8: 'var(--blue-a8)',
          a9: 'var(--blue-a9)',
          a10: 'var(--blue-a10)',
          a11: 'var(--blue-a11)',
          a12: 'var(--blue-a12)'
        },
        neutral: {
          1: 'var(--gray-1)',
          2: 'var(--gray-2)',
          3: 'var(--gray-3)',
          4: 'var(--gray-4)',
          5: 'var(--gray-5)',
          6: 'var(--gray-6)',
          7: 'var(--gray-7)',
          8: 'var(--gray-8)',
          9: 'var(--gray-9)',
          10: 'var(--gray-10)',
          11: 'var(--gray-11)',
          12: 'var(--gray-12)',
          a1: 'var(--gray-a1)',
          a2: 'var(--gray-a2)',
          a3: 'var(--gray-a3)',
          a4: 'var(--gray-a4)',
          a5: 'var(--gray-a5)',
          a6: 'var(--gray-a6)',
          a7: 'var(--gray-a7)',
          a8: 'var(--gray-a8)',
          a9: 'var(--gray-a9)',
          a10: 'var(--gray-a10)',
          a11: 'var(--gray-a11)',
          a12: 'var(--gray-a12)'
        }
      }
    }
  }
}

export default tailwindConfig
